var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundLandingpageMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 960 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b6d2d3;}.cls-2{fill:#9cc2c3;}.cls-3{fill:#679fa0;}.cls-4{fill:#73a6a7;}.cls-5{fill:#5b9797;}.cls-6{fill:url(#Unbenannter_Verlauf_2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    x1: 880,
    x2: 880,
    y2: 87.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#438989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeced"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 888.75,
    cy: 90.61,
    r: 0.91
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 888.75,
    cy: 72.82,
    r: 0.91
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 888.75,
    cy: 56.25,
    r: 0.91
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 888.75,
    cy: 39.63,
    r: 0.91
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 904.21,
    cy: 90.61,
    r: 0.91
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 904.21,
    cy: 72.82,
    r: 0.91
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 904.21,
    cy: 56.25,
    r: 0.91
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 904.21,
    cy: 39.63,
    r: 0.91
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 918.98,
    cy: 90.61,
    r: 0.91
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 918.98,
    cy: 72.82,
    r: 0.91
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 918.98,
    cy: 56.25,
    r: 0.91
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 918.98,
    cy: 39.63,
    r: 0.91
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 934.86,
    cy: 90.61,
    r: 0.91
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 934.86,
    cy: 72.82,
    r: 0.91
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 934.86,
    cy: 56.25,
    r: 0.91
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 951.6,
    cy: 90.61,
    r: 0.91
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 951.6,
    cy: 72.82,
    r: 0.91
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 951.6,
    cy: 56.25,
    r: 0.91
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 873,
    cy: 90.73,
    r: 0.91
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 873,
    cy: 72.93,
    r: 0.91
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 873,
    cy: 56.36,
    r: 0.91
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 873,
    cy: 39.74,
    r: 0.91
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 934.85,
    cy: 39.59,
    r: 0.91
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M800,0a30.82,30.82,0,0,1,10.25,7.49A34.74,34.74,0,0,1,817,19.31c1.89,5.23,1.79,7.59,4.41,14.83a38.43,38.43,0,0,0,2,4.58,51.21,51.21,0,0,0,8.06,11.42,40.42,40.42,0,0,0,25,12.76,293.23,293.23,0,0,0,31.39,1.34c13.87-.17,21.16-1.29,32.57.67,5.29.91,12.71,2,21,6.38A56.18,56.18,0,0,1,960,87.49V0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLandingpageMobile);
export default __webpack_public_path__ + "static/media/background_landingpage_mobile.8a167e4d133caac769b2ee7b41ec0771.svg";
export { ForwardRef as ReactComponent };